<template>
  <b-container id="customers-container" fluid class="no-sided-margin">
    <b-row>
      <b-col class="no-sided-padding">
        <b-tabs ref="customers-tabs" v-model="tab" fill pills card>
          <b-tab title="Ricerca">
            <div style="padding-top: 10px">
              <b-alert :show="showAlert" dismissible @dismissed="showAlert = false">
                La sezione Anagrafiche visualizza le anagrafiche dei clienti titolari di una carta fedeltà DAO e lo storico delle modifiche apportate. Permette la modifica dei dati di un cliente.
              </b-alert>
            </div>
            <Search :session="session"/>
          </b-tab>
          <b-tab title="Dettaglio anagrafica">
            <div style="padding-top: 10px">
              <b-alert :show="showAlert" dismissible @dismissed="showAlert = false">
                La sezione Anagrafiche visualizza le anagrafiche dei clienti titolari di una carta fedeltà DAO e lo storico delle modifiche apportate. Permette la modifica dei dati di un cliente.
              </b-alert>
            </div>
            <Details :session="session"/>
          </b-tab>
          <b-tab title="Storico Operazioni">
            <div style="padding-top: 10px">
              <b-alert :show="showAlert" dismissible @dismissed="showAlert = false">
                La sezione Anagrafiche visualizza le anagrafiche dei clienti titolari di una carta fedeltà DAO e lo storico delle modifiche apportate. Permette la modifica dei dati di un cliente.
              </b-alert>
            </div>
            <History/>
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
    <div style="float: right">
      <p style="font-size: 11px">Powered by <img width="100px" src="../assets/CherryChainLogo.png" alt="CherryChain"/></p>
    </div>
  </b-container>
</template>

<script>
import Search from '@/components/customers/Search'
import Details from '@/components/customers/Details'
import eventBus from '@/EventBus'
import History from '@/components/customers/History.vue'

export default {
  name: 'Customers',
  props: ['session'],
  components: { History, Search, Details},
  data: () => ({
    showAlert: false,
    CUSTOMER_RESEARCH: 0,
    CUSTOMER_DETAILS: 1,
    CUSTOMER_HISTORY: 2,
    tab: 0,
  }),
  mounted() {
    eventBus.$on("show-alert", () => this.showAlert = true)
    eventBus.$on('customer-selected', (customer) => {
      const tab = this.isEmpty(customer) ? this.CUSTOMER_RESEARCH : this.CUSTOMER_DETAILS;
      this.switchTab(tab)
    })
    eventBus.$on('customer-show-history', () => this.switchTab(this.CUSTOMER_HISTORY))
  },
  beforeDestroy() {
    eventBus.$off('customer-selected')
    eventBus.$off('customer-show-history')
    eventBus.$off('customers-searched')
  },
  methods: {
    isEmpty(object) { return Object.keys(object).length === 0 },
    switchTab(tab) { this.tab = tab }
  }
}
</script>

<style>
</style>
